import { ReadingSkills } from "./ReadingSkills.component";

export { ReadingSkills };
